__turbopack_context__.v({
  "pinned": "currency-module-scss-module__bj_Rgq__pinned",
});
